module.exports = __webpack_public_path__ + "img/logo-web-video-mini.7550798f.png";